import { Spinner } from '../components/spinner';
import { VStack } from '@terra/ui-styled-system';

export const FullScreenLoader = () => {
  return (
    <VStack h="full" justifyContent="center" alignItems="center" gap={4}>
      <Spinner size="xl" />
    </VStack>
  );
};
